<div id="ratio-overlay" [style.background]="isDarkTheme ? '#424242' : 'white'">
  <h3 [style.color]="isDarkTheme ? 'white' : 'black'">{{ 'component.surfaceRatioInfo' | transloco }}</h3>
  <div class="image-container">
    <img class="image" [src]="imageSource">
  </div>
</div>